/* istanbul ignore file */
import React from 'react';

function IconClose() {
  return /*#__PURE__*/React.createElement("svg", {
    className: "icon-chevron-left",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55.324 55.321",
    style: {
      width: 12
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "polygon",
    fill: "#ffffff",
    strokeWidth: "20",
    points: "47.393,0 27.677,19.709 8.531,0.563 0.602,8.491 19.752,27.635 0,47.387 7.931,55.321\n27.677,35.572 46.827,54.718 54.752,46.79 35.605,27.635 55.324,7.925 "
  }));
}

export default IconClose;